/** Persist last test case the user interacted with so Sidebar → History can open it. */
export const LAST_TEST_CASE_HISTORY_KEY = "qms.lastTestCaseIdForHistory";

export function setLastTestCaseForHistory(testCaseId) {
  if (testCaseId) {
    try {
      sessionStorage.setItem(LAST_TEST_CASE_HISTORY_KEY, String(testCaseId));
    } catch {
      /* ignore */
    }
  }
}

export function getLastTestCaseForHistory() {
  try {
    return sessionStorage.getItem(LAST_TEST_CASE_HISTORY_KEY);
  } catch {
    return null;
  }
}
